import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { usePrevious } from 'marketplace-ui-common/hooks/usePrevious';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useReviewContext } from './ReviewContextProvider';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewTextInput({
  dataTestId,
  disabled,
  fieldKey,
  injectedinput,
  label,
  onValueChange,
  placeholder,
  resize,
  rows,
  tooltip
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review,
    validationErrors
  } = useReviewContext();
  const {
    locked,
    minCharacters,
    maxCharacters,
    required
  } = getFieldValidation('content', fieldKey);
  const minCharactersError = !!validationErrors.find(({
    error,
    fieldKey: errorFieldKey,
    fieldType
  }) => error === 'minCharacters' && fieldType === 'content' && errorFieldKey === fieldKey);
  const maxCharactersError = !!validationErrors.find(({
    error,
    fieldKey: errorFieldKey,
    fieldType
  }) => error === 'maxCharacters' && fieldType === 'content' && errorFieldKey === fieldKey);
  const prevInjectInput = usePrevious(injectedinput);

  // Updates the stored value when the injected input changes
  useEffect(() => {
    if (injectedinput && injectedinput !== prevInjectInput) {
      onUpdateReview({
        content: {
          [fieldKey]: injectedinput
        }
      });
    }
  }, [injectedinput, onUpdateReview, prevInjectInput, fieldKey]);
  const showError = !!review.content[fieldKey] && (minCharactersError || maxCharactersError);
  const renderTextArea = ({
    onChange,
    value
  }) => /*#__PURE__*/_jsx(TextArea, {
    "data-test-id": dataTestId,
    disabled: disabled || locked,
    error: showError,
    onChange: e => {
      onUpdateReview({
        content: {
          [fieldKey]: e.target.value
        }
      });
      if (onChange) {
        onChange(e);
      }
      if (onValueChange) {
        onValueChange(e.target.value);
      }
    },
    placeholder: placeholder,
    resize: resize,
    rows: rows,
    value: value
  });
  const renderCharacterCounterLabel = count => {
    if (minCharactersError) {
      return /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: showError ? 'text-alert-default' : undefined,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trellisEcosystem.reviews.minimumCharacters",
          options: {
            limit: minCharacters
          }
        })
      });
    }
    if (maxCharacters) {
      return /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: showError ? 'text-alert-default' : undefined,
        children: maxCharacters - count
      });
    }
  };
  if (!maxCharacters && !minCharacters) {
    return /*#__PURE__*/_jsx(FormControl, {
      label: label,
      required: required,
      tooltip: tooltip,
      tooltipPlacement: "right",
      children: renderTextArea({
        value: review.content[fieldKey] || ''
      })
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: required,
    tooltip: tooltip,
    children: /*#__PURE__*/_jsx(CharacterCounter, {
      renderInput: ({
        onChange,
        value
      }) => renderTextArea({
        onChange,
        value
      }),
      label: ({
        count
      }) => renderCharacterCounterLabel(count),
      onChange: e => {
        if (onValueChange) {
          onValueChange(e.target.value);
        }
      },
      value: review.content[fieldKey] || ''
    })
  });
}